export const txt = {
    menu: {
      fr:"Menu",
      ar:"القائمة",
    },
    score: {
        fr: "Score",
        ar: "النتيجة",
    },
    unlockquestion: {
        fr: "Déverrouiller les questions",
        ar: "فتح الأسئلة",
    },
    unlockat5mad: {
        fr: "Débloquer à 5 DH",
        ar: "فتح في 5 دراهم",
    },
    confirmyoursubs: {
        fr: "Confirmez votre souscription",
        ar: "تأكيد اشتراكك",
    },
    activatedt: {
        fr: "Voulez-vous débloquer plus de questions",
        ar: "هل تريد فتح المزيد من الأسئلة مقابل",
    },
    confirmsubs:{
        fr: "Confirmez votre souscription",
        ar: "تأكيد اشتراكك",
    },
    lowbalance: {
        fr: "Solde insuffisant",
        ar: "الرصيد غير الكافي",
    },
    lbmsg: {
        fr: "Votre solde est insuffisant pour souscrire au Pass TRAVEL QUIZ. Veuillez recharger votre compte puis réessayer à nouveau.",
        ar: "رصيدك غير كافٍ لتشغيل خدمة TRAVEL QUIZ . الرجاء إعادة شحن حسابك ثم حاول مرة أخرى.",
    },
    tryagain: {
        fr: "Essayer à nouveau",
        ar: "حاول من جديد",
    },
    congrats: {
        fr: "Félicitations",
        ar: "تهانينا",
    },
    congtxt: {
        fr:"Votre nouveau pack de question à été débloqué avec succès",
        ar: "تم فتح حزمة الأسئلة الجديدة بنجاح",
    },
    playnow: {
        fr: "Fermer",
        ar: "اغلاق",
    },
    questions: {
        fr: "",
        ar: "",
    },
    folks: {
        fr: "C'est tout pour maintenant",
        ar: "هذا كل شيء الى حد الآن",
    },
    completedquestions: {
        fr: "Vous avez répondu à toutes les questions",
        ar: "لقد أجبت على جميع الأسئلة",
    },
    checkscorebtn:{
        fr: "vérifier le score",
        ar: "النتيجة",
    },
    unlockmorequestion: {
        fr: "débloquez de nouvelles questions",
        ar:"فتح أسئلة جديدة",
    },
    yourscore: {
        fr: "Votre score est",
        ar: "نتيجتك هي ",
    },
    ok :{
        fr:"D'accord",
        ar: "حسنًا",
    },
    gallery: {
        fr: "Galerie photos",
        ar: "معرض الصور",
    },
    unsub: {
        fr: "Se désabonner",
        ar: "إلغاء الاشتراك",
    },
    unsubtxt: {
        // fr: "Cliquez sur OK pour confirmer votre demande de désinscription. Une fois confirmée, vous recevrez un SMS de confirmation après traitement de votre demande.",
        // ar: "اضغط على الزر OK لتأكيد طلب إلغاء الاشتراك الخاص بك. بمجرد التأكيد ، ستتلقى رسالة تأكيد SMS بعد معالجة الطلب",
           fr:"Cliquez sur 'OK' pour confirmer le désabonnement. Une fois confirmé, vous allez recevoir un SMS de confirmation.Nous vous informons que vous pouvez perdre votre score après désabonnement.",
           ar:"	اضغط على الزر 'OK' لتأكيد طلب إلغاء الاشتراك الخاص بك. بمجرد التأكيد ، ستتلقى رسالة تأكيد SMS.نعلمك أنك قد تفقد رصيد نقاطك بعد إلغاء الاشتراك."
    },
    cnfrmunsub:{
        // fr: "Confirmer la désinscription",
        fr:"Confirmer le désabonnement",
        ar: "تأكيد إلغاء الاشتراك",
    },
    srymsg: {
        fr: "Nous sommes navrés de vous voir partir",
        ar: "نحن آسفون لمغادرتك",
    },
    gobacktosub: {
        fr: "Rejoindre à nouveau.",
        ar: "انضم مرة أخرى.",
    },
    oops: {
        fr: "Oops",
        ar: "عفوًا",
    },
    exhaustedtodaylimit: {
        fr: "vous avez épuisé votre limite hebdomadaire de questions. Veuillez revenir demain pour débloquer plus de questions.",
        ar: "لقد استنفدت الحد الأسبوعي للأسئلة. المرجو العودة غدا لفتح المزيد من الأسئلة.",   
    },
    scoreboard: {
        fr: "Tableau de bord",
        ar: "لوحة الدرجات",
    },
    chooselang: {
        fr: "Choisissez la langue",
        ar: "اختر اللغة",
    },
    unlockset: {
        fr: "vous ne pouvez débloquer qu'un seul ensemble",
        ar: "يمكنك فتح مجموعة واحدة فقط",
    },
    week1:{
        fr:"5MAD",
        ar:"5MAD",
    },
    ques:{
        fr: "des questions",
        ar: "أسئلة",
    },
    youcanchk: {
        fr: "vous pouvez vérifier votre score sur le tableau de bord",
        ar: "يمكنك التحقق من درجاتك على لوحة النتائج",
    },
    hurray: {
        fr: "Hourra!",
        ar: "هنيئًا!",
    },
    inching: {
        fr: "Vous approchez des vacances de vos rêves !",
        ar: "أنت تقترب من إجازة أحلامك!",
    },
    unsubfail: {
        fr: "échec de désabonnement",
        ar: "فشل إلغاء الاشتراك",
    },
    unsubfailmsg: {
        fr: "Désolé, votre demande de désabonnement a échoué",
        ar: "عذرًا، لقد فشل طلب إلغاء الاشتراك",
    },
    home: {
        fr: "Accueil",
        ar: "الصفحة الرئيسية",
    },
    welcome: {
        fr: "Bienvenue au concours Travel de rêve",
        ar: "مرحبا بكم في مسابقة رحلة الحلم",
    },
    thanku: {
        fr: "Merci",
        ar: "شكرًا لك",
    },
    confirmunlock: {
        // fr: "Confirmer le déverrouillage",
        // ar: "تأكيد الفتح",
        fr:"Confirmer",
        ar:"نعم"
    },
    tensectxt: {
        fr: "Vous avez 10 secondes pour répondre a chaque question",
        ar: "لديك 10 ثانية للإجابة على كل سؤال",
    }
}